export const conversationSlowThresholdMs = 10000;

export const conversationRequestTimeoutMs = 90000;

export const conversationRefusalReasons = {
    sellerChanged: 'CONVERSATION_SELLER_CHANGED',
    sellerRemoved: 'CONVERSATION_SELLER_REMOVED',
};

export const conversationViews = {
    history: 'history',
    conversation: 'conversation',
};

export const conversationHistoryTexts = {
    actionLabel: 'Ver conversas',
    loading: 'Carregando o histórico…',
    empty: 'Ainda não há conversas com este contato no Órbita.',
    expired: 'O histórico expirou. Tente de novo.',
    loadFailed: 'Não foi possível carregar o histórico do Órbita.',
    sendMessage: 'Enviar mensagem',
    openingConversation: 'Abrindo conversa…',
};

export const conversationTexts = {
    opening: 'Abrindo a conversa no Órbita…',
    loadingEmbed: 'Carregando a conversa…',
    slow: 'O Órbita está demorando mais que o normal. Isso pode levar até 1 minuto.',
    openFailed: 'Não foi possível abrir a conversa no Órbita.',
    timeout: 'O Órbita não respondeu a tempo. Tente de novo.',
    refreshOpportunity: 'Atualizar oportunidade',
};
